import React from "react";

function Code({ data }) {
  return (
    <div className="code section">
      <h2 className="otherhead">Code</h2>
      <div className="panel">
        {data ? (
          <pre>{data}</pre>
        ) : (
          <pre></pre>
        )}
      </div>
    </div>
  );
}

export default Code;
